import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '@/components/feature/Logo';
import LangToggle from '@/components/feature/LangToggle';

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navItems = [
    { key: 'nav.services', href: '#services' },
    { key: 'nav.cases', href: '#cases' },
    { key: 'nav.about', href: '#about' },
    { key: 'nav.contact', href: '#contact' },
  ];

  const isDark = scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isDark
          ? 'bg-background-50/90 backdrop-blur-xl border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10 h-[76px] flex items-center justify-between">
        <Logo variant={isDark ? 'dark' : 'light'} />

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.key}
              href={item.href}
              className={`px-4 py-2 text-sm rounded-full transition-all whitespace-nowrap cursor-pointer ${
                isDark
                  ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                  : 'text-background-100 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              {t(item.key)}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <LangToggle variant={isDark ? 'dark' : 'light'} />
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-foreground-950 text-sm font-semibold rounded-full transition-all whitespace-nowrap cursor-pointer"
          >
            {t('nav.cta')}
            <i className="ri-arrow-right-up-line text-base w-4 h-4 flex items-center justify-center" />
          </a>
        </div>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-full cursor-pointer ${
            isDark ? 'text-foreground-900 bg-background-100' : 'text-background-50 bg-background-950/30'
          }`}
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl w-5 h-5 flex items-center justify-center`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-6 py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.key}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-3 text-sm text-foreground-800 hover:bg-background-100 rounded-md whitespace-nowrap cursor-pointer"
              >
                {t(item.key)}
              </a>
            ))}
            <div className="flex items-center justify-between pt-3 border-t border-background-200 mt-2">
              <LangToggle variant="dark" />
              <a
                href="#contact"
                onClick={() => setMenuOpen(false)}
                className="px-4 py-2 bg-primary-500 text-foreground-950 text-sm font-semibold rounded-full whitespace-nowrap cursor-pointer"
              >
                {t('nav.cta')}
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}